import { useAppContext } from "context";

export const useFormatPrice = () => {
  const { settings } = useAppContext();
  // Default 3 decimals — matches 3-dp currencies (KWD/BHD/OMR) that are the
  // primary market. For 2-dp currencies settings.decimal is set explicitly.
  const decimal = Number.isFinite(settings?.decimal) ? settings.decimal : 3;
  const symbol = settings?.currSymbol ?? "$";

  return (price) => {
    const value = Number(price || 0);
    const formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    });
    // A non-breaking space, not a plain one: the currency symbol and the amount are
    // ONE word. A plain space lets a narrow card wrap "KD" onto its own line above
    // the figure, which reads as a broken number. Written as an escape so it survives
    // an editor that normalises whitespace. Layout only — the value is untouched.
    return `${symbol}\u00A0${formatted}`;
  };
};

// Same decimal rules as useFormatPrice, but WITHOUT the currency symbol.
// Used where the currency symbol lives on a column header instead of each cell
// (e.g. thermal receipt Price/Amount columns show "PRICE (KD)" then bare numbers).
export const useFormatNumber = () => {
  const { settings } = useAppContext();
  const decimal = Number.isFinite(settings?.decimal) ? settings.decimal : 3;

  return (v) =>
    Number(v || 0).toLocaleString(undefined, {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    });
};
